import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'project-comments-input, [project-comments-input], [projectCommentsInput]',
  standalone: false,
})
export class ProjectCommentsInputDirective {}
